import { FDBodyText, FDDisplayText } from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { withValueArray } from 'Helpers/MetaOverride';
import HeadlineTextLarge from 'Components/ComponentLibrary/Atoms/Text/HeadlineTextLarge';
import Image from 'Context/AnnouncementContext/Dialog/DialogContent/Image';
import StripeInput
  from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/EstatePlanningBuyPayment/Template/Layout/StripeInput/StripeInput';
import WizardFooterText from 'Views/Page/Content/Modal/Layouts/DefaultStep/Layout/WizardFooterText';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export default buildFacetDesignOverride()
  .nameOverride('subtitle', {
    _component: () => withValueArray(FDBodyText),
  }, overrideReadOnly)
  .nameOverride(['partnerText', 'recurringPaymentText', 'dueTodayText'], {
    _component: () => FDBodyText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
  }, overrideReadOnly)
  .nameOverride(['firstYearAmountWithDiscount'], {
    _component: () => Richtext,
    _customProps: { color: 'textSecondary', Component: FDDisplayText },
  }, overrideReadOnly)
  .nameOverride(['firstYearAmount', 'recurringPaymentAmount'], {
    _component: () => FDDisplayText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride('partnerImageURL', {
    _component: () => Image,
    _customProps: { noBorderRadius: true },
  }, overrideReadOnly)
  .nameOverride('stripeToken', {
    _component: () => StripeInput,
  }, overrideReadOnly)
  .nameOverride('footer', {
    _component: () => WizardFooterText,
  }, overrideReadOnly)
  .nameOverride('firstYearText', {
    _component: () => FDBodyText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly);
